import styled from 'styled-components';
import {Dialog, DialogActions, DialogContent, DialogTitle, TextField} from '@mui/material';
import { media } from '../../theme';

export const StyledDialog = styled(Dialog)`
    .MuiPaper-root {
        width: 100%;
        min-width: unset;

        ${media.sm} {
            min-width: 500px;
            width: 500px;
        }
    }
`;

export const StyledDialogTitle = styled(DialogTitle)`
`;

export const StyledDialogContent = styled(DialogContent)`
    padding:  16px 16px 32px 16px !important;
`;

export const StyledDialogActions = styled(DialogActions)`
    padding-top: 8px;
    padding-left: 24px;
    padding-bottom: 20px !important;
    padding-right: 20px !important;
    justify-content: flex-end;
`;

export const InputField = styled(TextField)`
`;